var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlGreenland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 22.5H0V45H60V22.5ZM52.5 22.5C52.5 26.4782 50.9196 30.2936 48.1066 33.1066C45.2936 35.9196 41.4782 37.5 37.5 37.5C33.5218 37.5 29.7064 35.9196 26.8934 33.1066C24.0804 30.2936 22.5 26.4782 22.5 22.5C22.5 18.5218 24.0804 14.7064 26.8934 11.8934C29.7064 9.08035 33.5218 7.5 37.5 7.5C41.4782 7.5 45.2936 9.08035 48.1066 11.8934C50.9196 14.7064 52.5 18.5218 52.5 22.5Z",
    fill: "#D00C33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlGreenland);
export default __webpack_public_path__ + "static/media/gl Greenland.be6ea5898cc62f29ed1e4e747fc4cd50.svg";
export { ForwardRef as ReactComponent };